import React, { useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from "xlsx"; // For exporting to Excel
import { Collapse } from "react-bootstrap";
import RequestServies from "../../../services/RequestServies";

const RequestItemSummary = () => {
    const [open, setOpen] = useState(true);
    const [open2, setOpen2] = useState(true);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [expandedStore, setExpandedStore] = useState(null); // Track currently expanded store

    const fetchReport = async () => {
        if (!fromDate || !toDate) {
            Swal.fire({
                icon: "warning",
                title: "Missing Dates",
                text: "Please select both From and To dates.",
            });
            return;
        }

        setLoading(true);
        try {
            const response = await RequestServies.reportGroupRequistion({
                fromDate: fromDate,
                toDate: toDate,
            });
            setReportData(response.data);
            Swal.fire({
                icon: "success",
                title: "Report Generated",
                text: `Report successfully generated for the selected date range.`,
            });
        } catch (error) {
            console.error("Error fetching report data:", error);
            Swal.fire({
                icon: "error",
                title: "Fetch Error",
                text: "Failed to fetch report data. Please try again later.",
            });
        } finally {
            setLoading(false);
        }
    };

    // Toggle the expanded store
    const toggleStoreDetails = (storeIndex) => {
        setExpandedStore((prevExpandedStore) => {
            // Collapse the previously expanded store, or expand the new one
            return prevExpandedStore === storeIndex ? null : storeIndex;
        });
    };

    // Calculate Pending and Approved counts for each store
    let totalCount = 0;
    let totalPending = 0;
    let totalapprovedByAdmin = 0;
    let totalapprovedCount = 0;
    let totalRejected = 0;
    let totalCompleted = 0;

    const calculateCounts = (store) => {
        const pendingCount = store.items.filter(item => item.status === "pending").length;
        const approvedByAdmin = store.items.filter(item => item.status === "approvedByAdmin").length;
        const approvedCount = store.items.filter(item => item.status === "approved").length;
        const rejectedCount = store.items.filter(item => item.status === "rejected").length;
        const recivedCount = store.items.filter(item => item.status === "recived").length;
        totalCount += store.items.length;
        totalPending += pendingCount;
        totalapprovedByAdmin += approvedByAdmin;
        totalapprovedCount += approvedCount;
        totalRejected += rejectedCount;
        totalCompleted += recivedCount
        return {
            pendingCount, approvedByAdmin, approvedCount, rejectedCount, recivedCount, totalCount, totalPending,
            totalapprovedByAdmin,
            totalapprovedCount,
            totalRejected,
            totalCompleted
        };
    };

    // Export to Excel
    const exportToExcel = () => {
        if (reportData.length === 0) {
            Swal.fire({
                icon: "info",
                title: "No Data",
                text: "No data available to download.",
            });
            return;
        }
        // Expand all items
        const expandedReportData = reportData.map((store, index) => {
            store.isExpanded = true; // Ensure all stores are expanded
            return store;
        });

        // Exporting the main table
        const mainTableData = reportData.map((store) => {
            const {
                pendingCount,
                approvedCount,
                approvedByAdmin,
                recivedCount,
                rejectedCount
            } = calculateCounts(store);

            return {
                From: fromDate,
                To: toDate,
                Store: store.storeName,
                Location: store.location,
                Count: store.itemCount,
                Rejected: rejectedCount,
                "Admin Pending": pendingCount,
                "SuperAdmin Pending": approvedByAdmin,
                "Receive Order Pending": approvedCount,
                Completed: recivedCount,
            };
        });


        // Create a new workbook and sheet
        const now = new Date();
        const date = now.toISOString().split("T")[0]; // YYYY-MM-DD format
        const time = now.toTimeString().split(" ")[0].replace(/:/g, "-"); // HH-MM-SS format
        const fileName = `Requisition_Summary_Report_${date}_${time}.xlsx`;

        // Add the detailed data for each store as separate sheets
        const wb = XLSX.utils.book_new();

        // Main sheet for the basic table
        const mainSheet = XLSX.utils.json_to_sheet(mainTableData);
        XLSX.utils.book_append_sheet(wb, mainSheet, "Main Table");

        // Sheets for each store with expanded details
        expandedReportData.forEach((store) => {
            const storeDetailsData = store.items.map((item, idx) => ({
                "#": idx + 1,
                "Part No": item.partNo,
                "Description": item.description,
                "Used Qty": item.usedQty,
                "Status": item.status,
                "Requistion No": item?.requisitionNo,
                "MRV No": item.mrvNo,
                "Admin Remark": item?.status === "pending" ? "Approval Pending" : "Completed",
            }));
            // Ensure the sheet name is not longer than 31 characters
            const sheetName = store.storeName.length > 31
                ? store.storeName.substring(0, 28) + "..."
                : store.storeName;

            const storeSheet = XLSX.utils.json_to_sheet(storeDetailsData);
            XLSX.utils.book_append_sheet(wb, storeSheet, sheetName);
        });

        // Download the Excel file
        XLSX.writeFile(wb, fileName);
        Swal.fire({
            icon: "success",
            title: "Download Successful",
            text: `File "${fileName}" has been downloaded successfully.`,
        });
    };

    return (
        <div className="col-xl-12">
            <div className="filter cm-content-box box-primary">
                <div className="content-title">
                    <div className="cpa">
                        <i className="fas fa-filter me-2"></i>Filter
                    </div>
                    <div className="tools">
                        <Link
                            to="#"
                            className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                            onClick={() => setOpen(!open)}
                        >
                            <i className="fas fa-angle-up"></i>
                        </Link>
                    </div>
                </div>
                <Collapse in={open}>
                    <div className="cm-content-body form excerpt">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-4 col-xxl-4">
                                    <label className="ms-2">From</label>
                                    <input
                                        type="date"
                                        name="fromDate"
                                        className="form-control mb-xxl-0 mb-3"
                                        value={fromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                    />
                                </div>

                                <div className="col-xl-4 col-xxl-4">
                                    <label className="ms-2">To</label>
                                    <input
                                        type="date"
                                        name="toDate"
                                        className="form-control mb-xxl-0 mb-3"
                                        value={toDate}
                                        onChange={(e) => setToDate(e.target.value)}
                                    />
                                </div>
                                <div className="col-xl-4 col-xxl-4">
                                    <label className="ms-2">Search</label>
                                    <button
                                        className="form-control btn btn-primary"
                                        onClick={fetchReport}
                                        disabled={loading}
                                    >
                                        {loading ? "Loading..." : "Generate Report"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Collapse>
            </div>

            <div className="filter cm-content-box box-primary">
                <div className="content-title">
                    <div className="cpa">
                        <i className="fa fa-list me-2" aria-hidden="true"></i>Requistion Summary Report
                    </div>
                    <div className="tools">
                        <Link
                            to={"#"}
                            className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                            onClick={() => setOpen2(!open2)}
                        >
                            <i className="fas fa-angle-up"></i>
                        </Link>
                    </div>
                </div>
                <Collapse in={open2}>
                    <div className="cm-content-body form excerpt">
                        <div className="card-body">
                        <div className="mb-3 text-end">
                                {!loading && reportData?.length > 0 ? (
                                    <p  onClick={exportToExcel}  className="text-end btn btn-rounded btn-md btn-primary me-3">
                                        <i className="las la-download scale5 me-3"></i> Download Report
                                    </p>
                                ) : (
                                    <p></p>
                                )}

                            </div>
                            <div className="table-responsive">
                               

                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>From</th>
                                            <th>To</th>
                                            <th>Store</th>
                                            <th>Location</th>
                                            <th>Count</th>
                                            <th>Rejected</th>
                                            <th>Admin Pending</th>
                                            <th>SuperAdmin Pending</th>
                                            <th>Receive Order Pending</th>
                                            <th>Completed</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reportData.length === 0 ? (
                                            <tr>
                                                <td colSpan="11">No data to display. Please generate a report.</td>
                                            </tr>
                                        ) : (
                                            <>
                                                {reportData.map((store, index) => {
                                                    const { recivedCount, pendingCount, approvedCount, approvedByAdmin, rejectedCount } = calculateCounts(store);
                                                    return (
                                                        <React.Fragment key={index}>
                                                            {/* Main Row */}
                                                            <tr>
                                                                <td>{fromDate}</td>
                                                                <td>{toDate}</td>
                                                                <td className="scrollable-description">{store.storeName}</td>
                                                                <td>{store.location}</td>
                                                                <td>{store.itemCount}</td>
                                                                <td>{rejectedCount}</td>
                                                                <td>{pendingCount}</td>
                                                                <td>{approvedByAdmin}</td>
                                                                <td>{approvedCount}</td>
                                                                <td>{recivedCount}</td>
                                                                <td>
                                                                    <div>
                                                                        Items: {store.itemCount}
                                                                        <i
                                                                            onClick={() => toggleStoreDetails(index)}
                                                                            className={`fas ${expandedStore === index
                                                                                ? "fa-chevron-up"
                                                                                : "fa-chevron-down"
                                                                                } ms-2`}
                                                                            style={{ cursor: "pointer" }}
                                                                        ></i>
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            {/* Collapsible Row */}
                                                            {expandedStore === index && (
                                                                <tr>
                                                                    <td colSpan="11" className="p-0">
                                                                        <h4 className="text-center mt-3 mb-3 bg-primary">Item Details</h4>
                                                                        <Collapse in={expandedStore === index}>
                                                                            <div className="store-details mt-3">
                                                                                <div className="table-responsive">
                                                                                    <table className="table table-bordered table-striped">
                                                                                        <thead>
                                                                                            <tr>
                                                                                                <th>#</th>
                                                                                                <th>Part No</th>
                                                                                                <th>Description</th>
                                                                                                <th>Required Qty</th>
                                                                                                <th>Approved Qty</th>
                                                                                                <th>Received Qty</th>
                                                                                                <th>Status</th>
                                                                                                <th>Requistion No</th>
                                                                                                <th>MRV No</th>
                                                                                                <th>Admin Remark</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {store.items.map((item, idx) => (
                                                                                                <tr key={idx}>
                                                                                                    <td>{idx + 1}</td>
                                                                                                    <td>{item.partNo}</td>
                                                                                                    <td className="scrollable-description">{item.description}</td>
                                                                                                    <td>{item.requiredQty}</td>
                                                                                                    <td>{item.approveQty}</td>
                                                                                                    <td>{item.qtyRecived}</td>
                                                                                                    <td>{item.status}</td>
                                                                                                    <td>{item?.requisitionNo}</td>
                                                                                                    <td>{item?.mrvNo}</td>

                                                                                                    <td>
                                                                                                        {item?.status === "pending"
                                                                                                            ? "Approval Pending by Admin"
                                                                                                            : item?.status === "approved"
                                                                                                                ? "Pending for Receive"
                                                                                                                : item?.status === "approvedByAdmin"
                                                                                                                    ? "SuperAdmin Approval Pending"
                                                                                                                    : item?.status === "recived"
                                                                                                                        ? "Completed"
                                                                                                                        : item?.status === "rejected"
                                                                                                                            ? "Rejected"
                                                                                                                            : "Unknown Status"}
                                                                                                    </td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                        </Collapse>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    );
                                                })}
                                                {/* Total Count Row */}
                                                <tr className="bg-light fw-bold">
                                                    <td colSpan="4" className="text-center">Total Count</td>
                                                    <td>{totalCount}</td>
                                                    <td>{totalRejected}</td>
                                                    <td>{totalPending}</td>
                                                    <td>{totalapprovedByAdmin}</td>
                                                    <td>{totalapprovedCount}</td>
                                                    <td>{totalCompleted}</td>
                                                    <td></td>
                                                </tr>
                                            </>
                                        )}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    </div>
                </Collapse>
            </div>
        </div>
    );
};

export default RequestItemSummary;
